export default class API {
    constructor() {
        this._xhr = null;
    }

    get({ url, data = '', loaderContainer, progress, method = 'get' }) {
        this._xhr && this._xhr.abort();

        this._xhr = $.ajax({
            method: method,
            url,
            data,
            processData: false,
            contentType: false,
            beforeSend: () => {
                loaderContainer
                && loaderContainer.length
                && loaderContainer.addClass('loading');
            },
            xhr: function () {
                const xhr = new window.XMLHttpRequest();

                typeof progress === 'function' && xhr.addEventListener('progress', progress);

                return xhr;
            }
        }).done(() => {
            loaderContainer && loaderContainer.removeClass('loading');
        }).fail(() => {
            loaderContainer && loaderContainer.removeClass('loading');
        });

        return this._xhr;
    }
}



// WEBPACK FOOTER //
// ./components/api.js